export default __webpack_public_path__ + "static/media/landing-up-btn.31c88e78.svg";